import axios from "axios";
import Swal from "sweetalert2";

import { baseUrl } from "../util";

export const submitEPRAnswers = ({
  businessId,
  answers,
  year,
  period,
  allocated_year,
  loading = null,
  setLoading = null,
  useToast = false,
  callback = null,
  setErrorMessage = () => {},
}) => {
  const data = {
    business: businessId,
    year: year,
    period: period,
    allocated_year: allocated_year,
    ...answers,
  };

  const config = {
    method: "post",
    url: baseUrl + "/api/business/epr-answers/",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  if (loading && setLoading) setLoading("loading");

  axios(config)
    .then((response) => {
      if (useToast) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading && setLoading) setLoading("success");
      if (callback) callback(response.data);
      setErrorMessage();
    })
    .catch((error) => {
      console.error("Error submitting ERP answers:", error);
      setErrorMessage(error.response?.data || "An error occurred");
      if (loading && setLoading) setLoading("failed");
      if (useToast) {
        Swal.fire({
          title: "Error",
          icon: "error",
          text: "Failed to submit ERP answers. Please try again.",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const updateEPRAnswers = ({
  businessId,
  answers,
  year,
  period,
  allocated_year,
  loading = null,
  setLoading = null,
  useToast = false,
  callback = null,
  setErrorMessage = () => {},
  setObjects = () => {},
}) => {
  const data = {
    business: businessId,
    year: year,
    period: period,
    allocated_year: allocated_year,
    ...answers,
  };

  const config = {
    method: "put",
    url: baseUrl + "/api/business/epr-answers/",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  if (loading && setLoading) setLoading("loading");

  axios(config)
    .then((response) => {
      if (useToast) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading && setLoading) setLoading("success");
      if (callback) callback(response.data);
      setErrorMessage();
      setObjects(response.data);
    })
    .catch((error) => {
      console.error("Error updating ERP answers:", error);
      setErrorMessage(error.response?.data || "An error occurred");
      if (loading && setLoading) setLoading("failed");
      if (useToast) {
        Swal.fire({
          title: "Error",
          icon: "error",
          text: "Failed to update ERP answers. Please try again.",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const getEPRAnswers = ({
  businessId,
  year,
  period,
  setObjects = function () {
    return;
  },
  setIsQASubmitted = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/epr-answers/",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business: businessId,
      year: year,
      period: period,
    },
  };

  axios(config)
    .then(function (response) {
      if (response.data && response.data.length > 0) {
        setIsQASubmitted(true);
      }

      setObjects(response.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};
